import { TableHeaderProps, TotalItemsLabel } from '@/components';
import { TableHeaderLayout } from '@/layouts';

export const IngredientsToolBar = ({
  count,
  selectedRows,
  onDelete,
  onDeactivate,
  onActivate,
  onDuplicate,
  onCancel,
}: TableHeaderProps) => (
  <TableHeaderLayout
    selectedRows={selectedRows}
    onDeactivate={onDeactivate}
    onActivate={onActivate}
    onDuplicate={onDuplicate}
    onCancel={onCancel}
    onDelete={onDelete}
    actions={{ onDelete: true, onDuplicate: true, onDeactivate: true, onActivate: true }}
  >
    <TotalItemsLabel count={count} />
  </TableHeaderLayout>
);
